import { Component, OnInit } from '@angular/core';
import { SettingService } from '../../../settings/services/setting.service';

@Component({
    selector: 'layout-blank-aside',
    templateUrl: './blank-aside.component.html',
    styleUrls: ['./blank-aside.component.scss']
})
export class BlankAsideComponent implements OnInit {

    public background = '';

    constructor(public settings: SettingService) {
    }

    ngOnInit() {
        this.settings.get('appearance.frontpage.background', (file) => {
            this.background = 'url(' + file + ')';
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/blank-aside/blank-aside.component.ts